import { FAIL_FETCH } from './Other'
import { store } from '../../App'
export const FETCH_SEARCH_CONTENT = 'FETCH_SEARCH_CONTENT'
export const FETCH_SEARCH_USERS = 'FETCH_SEARCH_USERS'
export const LOAD_SEARCH_USERS = 'LOAD_SEARCH_USERS'
export const LOAD_SEARCH_CONTENT = 'LOAD_SEARCH_CONTENT'

/**
  * fetchSearchResults
  * @desc generate a fetch search action
  * @param id
  * @param {string} dropdownSelected dropdownSelected
  * @param {string} searchTerm
  * @param options
  * @return {action} action
*/
export function fetchSearchResults (id, dropdownSelected, searchTerm, options) {
  const query = { accountId: id, searchTerm }

  if (options.limit) {
    query.limit = options.limit
  }
  if (options.offset) {
    query.offset = options.offset
  }
  query.appProfileIds = store.getState().filterSources.profiles.map(profile => profile._id)
  if (store.getState().filterSources.profiles[0]._id === '0') {
    return { type: FAIL_FETCH }
  }
  query.groupIds = store.getState().filterSources.groups.map(group => group._id)

  let type = FAIL_FETCH
  let searchType = ''
  switch (dropdownSelected) {
    case 'Content Title':
      searchType = 'CONTENT'
      type = FETCH_SEARCH_CONTENT
      break
    case 'User Name':
      searchType = 'USER_NAME'
      type = FETCH_SEARCH_USERS
      break
    case 'User Email':
      searchType = 'USER_EMAIL'
      type = FETCH_SEARCH_USERS
      break
    default:
  }
  query.searchType = searchType
  query.userType = 'Admin' // CHANGE IT LATER

  return { type, query }
}

/**
 * loadSearchUsers
 * @desc Load Users
 * @param type
 * @param {Object} data data to load
 * @return {action} loadUsersAction
 */
export function loadSearchResults (type, data) {
  return { type, data }
}

/**
 * loadSearchContent
 * @desc Load Content
 * @param {Object} data data to load
 * @return {action} loadUsersAction
 */
export function loadSearchContent (data) {
  return { type: LOAD_SEARCH_CONTENT, data }
}
